import { Star } from "lucide-react";
import { ProductCard } from "@/components/site/ProductCard";
import type { Product } from "@/lib/products";
import type { ProductRating } from "@/lib/reviews.functions";

/**
 * ProductCard with an OPTIONAL real rating row underneath.
 *
 * If `rating` is omitted (no reviews yet for this product), the rating row
 * is not rendered at all — quiet by default. We never invent counts.
 */
export function RatedProductCard({
  product,
  index = 0,
  eager = false,
  rating,
}: {
  product: Product;
  index?: number;
  eager?: boolean;
  rating?: ProductRating;
}) {
  const filled = rating ? Math.round(rating.avg) : 0;
  return (
    <div className="flex flex-col">
      <ProductCard product={product} index={index} eager={eager} />
      {rating && rating.count > 0 && (
        <div
          className="mt-3 flex items-center justify-center gap-2"
          aria-label={`${rating.avg.toFixed(1)} out of 5 from ${rating.count} reviews`}
        >
          <div className="flex items-center gap-0.5" aria-hidden="true">
            {Array.from({ length: 5 }).map((_, k) => (
              <Star
                key={k}
                className={`h-3 w-3 ${k < filled ? "fill-gold text-gold" : "text-stone/40"}`}
              />
            ))}
          </div>
          <span className="text-[10px] uppercase tracking-[0.24em] text-stone tabular-nums">
            {rating.count.toLocaleString()} {rating.count === 1 ? "review" : "reviews"}
          </span>
        </div>
      )}
    </div>
  );
}
